// extracted by mini-css-extract-plugin
export default {"button":"Button_button__KXFVC","primary":"Button_primary__Gs9eZ","secondary":"Button_secondary__G-ccb"};